<ng-container *transloco="let t">
  <h3>{{ t('driver-analysis-dialog.analysis-target-step.choose-metric') }}</h3>

  @if (isLoading) {
    <div class="xi-loader-container__center">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="anlaysis-target-step__scroll-container">
    @if (!isLoading && !availableTargetFields?.length) {
      <p>
        {{ t('driver-analysis-dialog.analysis-target-step.no-fields-available') }}
      </p>
    }
    @for (field of availableTargetFields; track field) {
      <div class="analysis-target-step__target-metric-row">
        <xi-radio
          [value]="field.value"
          [(ngModel)]="data.dependentColumn"
          [label]="field.label"
          (onChange)="onValidityChange.emit(true)"
          name="analysisTarget"
        >
        </xi-radio>
      </div>
    }
  </div>
</ng-container>
